import { invoiceSlice } from '../slices';
import store from '../../store';
import { axios } from '../../libs';
const { nError } = window;

const Actions = invoiceSlice.actions;
const { dispatch, getState } = store;

const set = (data) => {
  dispatch(Actions.set(data));
};

const get = () => {
  return (state) => state.invoices;
};

const fetchInvoices = async () => {
  try {
    const { invoices } = await axios.get('/invoice');
    dispatch(Actions.set({ invoices }));
    return invoices;
  } catch (error) {
    nError({ title: 'Error fetching invoices' });
    return false;
  }
};

export const Invoice = {
  set,
  get,
  fetchInvoices,
};